'use client';
import React from 'react';
import {
    CloudinaryType,
    TypeBlockPageIntro,
    TypeImageWrapper,
    TypePageWithoutUnresolvedLink,
} from '@fm-nx/contentful-types';

type HeroDisplayProps = {
    intro: TypeBlockPageIntro<'WITHOUT_UNRESOLVABLE_LINKS'>;
    page?: TypePageWithoutUnresolvedLink;
    backgroundImage?: TypeImageWrapper<'WITHOUT_UNRESOLVABLE_LINKS'>;
    backgroundImageOpacity?: number;
};

// technically this is a landing page intro I think
// Right now there is only one option: blockImageOverlayIntro
export const HeroDisplay = (props: HeroDisplayProps) => {
    // Cast the cloudinaryMedia to an array of CloudinaryType
    const cloudinaryMedia = props.backgroundImage?.fields.cloudinaryMedia as Array<CloudinaryType> | undefined;
    const bgImageUrl = cloudinaryMedia?.[0]?.secure_url;

    return (
        <div className="relative w-full py-24 overflow-hidden sm:py-32">
            {bgImageUrl && (
                <img
                    alt=""
                    src={bgImageUrl}
                    className="absolute inset-0 object-cover object-right -z-10 size-full md:object-center"
                    style={{ opacity: (bgImageUrl && props.backgroundImageOpacity) || 0.5 }}
                />
            )}
            <div className="px-6 mx-auto max-w-7xl lg:px-8">
                <div className="max-w-2xl mx-auto lg:mx-0">
                    <h2 className="text-5xl font-semibold tracking-tight text-white sm:text-7xl">Work with us</h2>
                    <p className="mt-8 text-lg font-medium text-gray-300 text-pretty sm:text-xl/8">
                        Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo. Elit
                        sunt amet fugiat veniam occaecat fugiat.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default HeroDisplay;
